// エリア検索ページ（search.area）の種別ラジオ変更に応じて、
// 市区町村別の件数をAJAXで再計算しフロントに反映する（ページリロード無し）
//
// 【2026-08-21 チェックボックス → ラジオ。設計メモ D25】
// 送るのは常に1種別。「全種別解除」という状態が無くなったので、
// それに備えていた送信ボタンの無効化は撤去した（種別0件は起こり得ない）。
// 送信ボタンの活性はエリア選択の件数（CountAction の countChange）だけが決める
const areaTypeFilter = () => {
    const tabsRoot = document.querySelector('.c-search-type-tabs[data-mode="radio"]');
    const typeInputs = tabsRoot ? [...tabsRoot.querySelectorAll('input[type="radio"]')] : [];
    const listRoot = document.querySelector('[data-pickup-search]');
    if (!typeInputs.length || !listRoot) return;

    const baseUrl = listRoot.dataset.areaCountsUrl;
    if (!baseUrl) return;

    const setLoading = (loading) => {
        // 未キャッシュの種別は実APIを叩くため待ちが発生し得る。
        // 操作中の二重送信・結果の取り違えを防ぐため、取得中はラジオを一時的に無効化する
        tabsRoot?.toggleAttribute('data-loading', loading);
        typeInputs.forEach((input) => { input.disabled = loading; });
    };

    const update = async () => {
        const selected = typeInputs.find((i) => i.checked)?.value;
        // サーバが1つも checked を出さなかった場合の保険。件数は前回値のまま残す
        if (!selected) return;

        // 選ばれているのは必ず実在の4種別のどれか。
        // 【2026-08-21 「すべて」タブ（value=all）の撤去に伴い分岐を1つ削除】
        // 以前は「'all' のときは type を積まずに投げる」（サーバ側が type 未指定を 'all' へ
        // 丸めるのに対し、type=all と明示すると normalizeEstateType() が 'all' を返して
        // 別経路に入るため）としていたが、'all' は選択肢から消えたので到達不能になった。
        // 「type を積まない＝種別未指定」というサーバ側の解釈自体は変わっていない
        const params = new URLSearchParams();
        params.append('type[]', selected);

        setLoading(true);
        try {
            const res = await fetch(`${baseUrl}?${params.toString()}`);
            if (!res.ok) throw new Error(`APIエラー: ${res.status}`);
            const { cities } = await res.json();

            listRoot.querySelectorAll('[data-block]').forEach((block) => {
                const key = block.dataset.key;
                const city = cities[key];
                if (!city) return;

                block.dataset.count = city.count;
                const parentCount = block.querySelector('[data-parent] [data-count]');
                if (parentCount) {
                    parentCount.dataset.count = city.count;
                    parentCount.textContent = city.count;
                    // 分譲地は表示を持たないので data 属性だけ差し替える（textContentはプランのまま）
                    parentCount.dataset.countLot = city.lot_count ?? 0;
                }

                block.querySelectorAll('[data-child] input[type="checkbox"]').forEach((child) => {
                    const childCount = city.children?.[child.value];
                    if (childCount === undefined) return;
                    const countEl = child.closest('label')?.querySelector('[data-count]');
                    if (countEl) {
                        countEl.dataset.count = childCount;
                        countEl.textContent = childCount;
                        countEl.dataset.countLot = city.children_lot?.[child.value] ?? 0;
                    }
                    // 表示・活性はプラン基準のまま。分譲地だけある市区町村は存在しない
                    // （多棟の親は必ず子を伴う）ので、0件で閉じても取りこぼしは起きない
                    child.disabled = childCount === 0;
                });
            });

            // 件数(data-count / data-count-lot)を更新した後、CountActionに再集計させる
            listRoot.dispatchEvent(new CustomEvent('countRecalc'));
        } catch (error) {
            console.warn('エリア件数APIの取得に失敗しました:', error);
        } finally {
            setLoading(false);
        }
    };

    typeInputs.forEach((input) => input.addEventListener('change', update));
};

export default areaTypeFilter;
